import type { VehicleBlueprint, CameraConfig } from "@neon-arena/shared";

export interface FirstPersonEye {
  /** World-space height above ground for the camera eye position. */
  eyeAboveGround: number;
  /** Forward offset from vehicle centre along the vehicle's forward axis. */
  eyeForward: number;
}

/**
 * Compute the first-person eye position from vehicle geometry and camera config.
 *
 * eyeAboveGround = body.height × firstPersonHeight + wheels.size × 0.5
 * eyeForward     = body.length × firstPersonForward
 *
 * At DEFAULT_GAME_CONFIG.camera defaults (height 0.85, forward 0.2) this produces
 * identical output to the previous hardcoded constants.
 */
export function computeFirstPersonEye(bp: VehicleBlueprint, cfg: CameraConfig): FirstPersonEye {
  return {
    eyeAboveGround: bp.body.height * cfg.firstPersonHeight + bp.wheels.size * 0.5,
    eyeForward:     bp.body.length * cfg.firstPersonForward,
  };
}
